import type { ReactNode } from 'react';
import { cn } from '@/utils/helpers';

interface BadgeProps {
  children: ReactNode;
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'neutral';
  color?: string;
  size?: 'sm' | 'md';
  className?: string;
}

export default function Badge({
  children,
  variant = 'neutral',
  color,
  size = 'sm',
  className,
}: BadgeProps) {
  const variants = {
    success: 'bg-success/15 text-success',
    warning: 'bg-warning/15 text-warning',
    danger: 'bg-danger/15 text-danger',
    info: 'bg-info/15 text-info',
    neutral: 'bg-navy-hover text-ink-secondary',
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  };

  const customStyle = color
    ? { backgroundColor: `${color}20`, color: color }
    : undefined;

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-sm whitespace-nowrap',
        sizes[size],
        !color && variants[variant],
        className
      )}
      style={customStyle}
    >
      {children}
    </span>
  );
}
